import generateRender from 'shared/utils/generateRender';
import DefaultVipHeader from './DefaultVipHeader';

const VipAccessHeader = generateRender({
  default: DefaultVipHeader,
});

export default VipAccessHeader;

